import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import SketchfabSingleModel from '../../common/SketchfabSingleModel'

const FashionModeling = () => {
  return (
    <>
      <Card className="fashion-modeling-container text-center no-border rounded-0 container">
      <Card.Body>
        <Card.Title className='fashion-modeling-title py-1'> ファッションモデリング </Card.Title>
        <Card.Text className='fashion-modeling-text py-1 text-left'>
        布や髪、毛皮など、動きのあるソフトなスタイルのモデリング技術は進化を続けています。ファッションマーケティングにおけるバーチャル撮影に加え、ARを使ったバーチャル試着は、消費者が期待する新しいスタンダードになりつつあります。これは、モデルではなく、自分の動きにぴったり合った服を着用している姿を見たい、という消費者のニーズに応えたものです。
        </Card.Text>
        <Row className='pt-1 pt-md-5'>
            <Col id="first" sm={12} md={7}>
                <div className="fashion-modeling-player">
                    <SketchfabSingleModel  modelId="d31929fcfedb49dca7965bee1b6da8ac"  />
                </div>
            </Col>
            <Col id="second" sm={12} md={5} className="fashion-grid">
                <Row sm={1} md={2} className='g-4 fashion-modeling-grid'>
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={"/assets/fashion/thumbnail/dress01.jpg"} alt=" " />
                    </Col>
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={"/assets/fashion/thumbnail/dress02.jpg"} alt=" " />
                    </Col>
                {/* </Row>
                <Row> */}
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={"/assets/fashion/thumbnail/dress04.jpg"} alt=" " />
                    </Col>
                    <Col className="fashion-modeling-thumbnail">
                        <img className="fashion-modeling-image" src={"/assets/fashion/thumbnail/dress03.jpg"} alt=" " />
                    </Col>
                </Row>
            </Col>
        </Row>
      </Card.Body>
    </Card>
    </>
  )
}

export default FashionModeling
